module.exports = __webpack_public_path__ + "media/level_up_3.1a1c63fd.mp3";